import { v4 } from 'uuid'
import environment from '../environment'

type HttpClientOptions = {
  isRelativeUrl?: boolean
}

export const useHttpClient = ({ isRelativeUrl = false }: HttpClientOptions = {}) => {
  return async <T>(url: string, options: RequestInit = {}): Promise<T> => {
    const correlationId = v4()
    const response = await fetch(isRelativeUrl ? url : `${environment.gatewayEndpoint}/${url}`, {
      ...options,
      headers: {
        ...options.headers,
        'X-Correlation-Id': correlationId,
      },
    })

    const contentType = response.headers.get('content-type') || ''

    if (['application/octet-stream', 'image/png'].includes(contentType)) {
      // default nestjs streamablefile content-type
      return response.blob() as T
    }

    if (!response.ok) {
      throw new Error(response.statusText)
    }

    const data = (await response.json()) as T

    return data
  }
}

export const getHttpClient = useHttpClient
